import { React, Modal, Heading } from 'mondrian-react'

const FaturaModal = ({ isOpen, onCloseClick }) => {

  const ModalContent = () => (
    <div className="mcm-Modal-content">
      <p className="mdn-Text">Para aumentar ou reduzir a fonte, utilize os atalhos nativos do seu navegador:</p>
      <ul className="mcm-Modal-content__list">
        <li className="mcm-Modal-content__item mdn-Text">No windows <strong>Control+</strong> (para aumentar) e <strong>Control-</strong> (para diminuir)</li>
        <li className="mcm-Modal-content__item mdn-Text">No macOS (safari) <strong>cmd+</strong> (para aumentar) e <strong>cmd-</strong> (para diminuir)</li>
      </ul>
    </div>
  )

  return (
    <Modal
      sm
      data={{
        header: <Heading sm>Alterar zoom</Heading>,
        content: <ModalContent />,
        isOpen: isOpen,
        onCloseClick: () => onCloseClick()
      }}
    />
  )
}

export default FaturaModal